<template>
  <ModalConfirmation
    :isShowConfirmDeleteMessage="false"
    customWidth="460px"
    :ariaLabel="i18n.title"
    @close="$emit('close')">
    <h3 slot="item">{{ i18n.title }}</h3>
    <template slot="custom_warning">
      <p class="spuc__intro">{{ introText }}</p>
      <table class="spuc__table">
        <thead>
        <tr>
          <th>{{ i18n.calendar }}</th>
          <th class="spuc__num">{{ i18n.current }}</th>
          <th class="spuc__num">{{ i18n.new }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in poolRows" :key="row.calendarId">
          <td>{{ row.name }}</td>
          <td class="spuc__num spuc__old">{{ row.hours }}</td>
          <td class="spuc__num spuc__newval">{{ formattedNewHours }}</td>
        </tr>
        </tbody>
      </table>
    </template>
    <template slot="confirm_buttons">
      <button @click.stop="$emit('subjectOnly')">{{ i18n.only_subject }}</button>
      <button class="bttn bttn--submit" @click.stop="onUpdateAll">{{ i18n.update_all }}</button>
    </template>
  </ModalConfirmation>
</template>

<script>
import ModalConfirmation from '../Modals/ModalConfirmation'
import {getDifferentiatedPools} from '../../utils/subjectPools'

const I18N = {
  da: {
    title: 'Opdatér puljer?',
    intro: 'Faget har puljer, der ikke følger brikken. Vil du opdatere dem alle til %{hours} klokketimer?',
    calendar: 'Kalender',
    current: 'Nuværende',
    new: 'Ny',
    only_subject: 'Kun brikken',
    update_all: 'Opdatér alle puljer'
  },
  nb: {
    title: 'Oppdatere puljer?',
    intro: 'Faget har puljer som ikke følger brikken. Vil du oppdatere dem alle til %{hours} timer?',
    calendar: 'Kalender',
    current: 'Nåværende',
    new: 'Ny',
    only_subject: 'Kun faget',
    update_all: 'Oppdater alle puljer'
  },
  en: {
    title: 'Update pools?',
    intro: 'The subject has pools that do not follow the subject. Do you want to update them all to %{hours} hours?',
    calendar: 'Calendar',
    current: 'Current',
    new: 'New',
    only_subject: 'Subject only',
    update_all: 'Update all pools'
  }
}

export default {
  components: {ModalConfirmation},
  props: {
    subject: {
      type: Object,
      required: true
    },
    newHours: {
      default: null
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N.da
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash || {}
    },
    formattedNewHours () {
      return this.newHours === null || this.newHours === undefined ? '' : this.newHours
    },
    introText () {
      return this.i18n.intro.replace('%{hours}', this.formattedNewHours)
    },
    poolRows () {
      return getDifferentiatedPools(this.subject, this.newHours).map(pool => ({
        calendarId: pool.calendarId,
        hours: pool.hours,
        name: this.calendarName(pool.calendarId)
      }))
    }
  },
  methods: {
    calendarName (calendarId) {
      const cals = this.subject && this.subject.cals
      if (Array.isArray(cals)) {
        for (let i = 0; i < cals.length; i++) {
          if (cals[i] && cals[i].id === calendarId) {
            return cals[i].name
          }
        }
      }
      const fromStore = this.allCalendarsInHash[calendarId]
      if (fromStore && fromStore.name) {
        return fromStore.name
      }
      return '' + calendarId
    },
    onUpdateAll () {
      this.$emit('updateAll', this.poolRows.map(row => row.calendarId))
    }
  }
}
</script>

<style scoped>
.spuc__intro {
  padding: 1.5rem 1rem 0.5rem 1rem;
  margin: 0;
}

.spuc__table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 0 0.5rem 0;
  font-size: 13px;
}

.spuc__table th,
.spuc__table td {
  padding: 0.35rem 1rem;
  text-align: left;
}

.spuc__table thead th {
  color: #8898aa;
  text-transform: uppercase;
  font-size: 11px;
  border-bottom: 1px solid #e2e8f0;
}

.spuc__table tbody tr:not(:last-child) td {
  border-bottom: 1px solid #f0f3f7;
}

.spuc__num {
  text-align: right;
}

.spuc__old {
  color: #8898aa;
  text-decoration: line-through;
}

.spuc__newval {
  font-weight: bold;
  color: #2f855a;
}
</style>



// WEBPACK FOOTER //
// SubjectPoolsUpdateConfirm.vue?1a203ea0